import axios from 'axios';
import errorHandlerFactory from './errorHandler';
import {
    pricingParametersGridTransform, importSensitivitiesAdapter,
    loadTradesIntoPricingParams, mapSaveAsTemplateRows
} from './adapters/pricingParametersSubmit';
import { filterSummaries } from './adapters/csaImpactAdapter';


const errorHandler = errorHandlerFactory('An error occured when fetching Pricing Parameters.');
const templateSaveErrorHandler = errorHandlerFactory('An error occured when saving a template.');
const loadTemplatesNamesErrorHandler = errorHandlerFactory('An error occured when fetching the list of templates.');
const loadIndividualTemplateName = errorHandlerFactory('An error occured when fetching the template.');
const deleteTemplateErrorHandler = errorHandlerFactory('An error occured when deleting the template.');
const pricingParameterValidateErrorHandler = errorHandlerFactory('The pricing parameters data is invalid');
const pricingParameterSubmitErrorHandler = errorHandlerFactory('An error occured when submitting pricing parameters rows');
const importSensitivitiesErrorHandler = errorHandlerFactory('An error occured when importing sensitivities');
const fxRatesErrorHandler = errorHandlerFactory('An error occured when fetching FX Rates');
const defaultBucketErrorHandler = errorHandlerFactory('An error occured when fetching the default bucket');

export const pricingParamsMetaData = (runDate, csa) => axios.get('/csaimpact/GetCsaCrifMetadata', { params: { runDate, csa } })
    .then(r => r.data).catch(errorHandler);

export const saveTemplate = params => axios.post('/CsaImpact/SaveTemplate', mapSaveAsTemplateRows(params))
    .then(r => r.data).catch(templateSaveErrorHandler);

export const deleteTemplate = templateName => axios.delete(`/CsaImpact/deleteTemplate?templateName=${templateName}`)
    .then(r => r.data).catch(deleteTemplateErrorHandler);

export const loadTemplatesNames = () => axios.get('/CsaImpact/getTemplateNames')
    .then(r => r.data).catch(loadTemplatesNamesErrorHandler);

export const loadIndividualTemplate = templateName => axios.get(`/CsaImpact/loadTemplate?templateName=${templateName}`)
    .then(r => loadTradesIntoPricingParams(r.data)).catch(loadIndividualTemplateName);

export const submitPricingParamsRows = params => axios.post('/CsaImpact/AddNewTradeComp', pricingParametersGridTransform(params))
    .then(r => filterSummaries(r.data)).catch(pricingParameterSubmitErrorHandler);

export const validatePricingParams = params => axios.post('/CsaImpact/ValidatePricingParams', pricingParametersGridTransform(params))
    .then(r => (r.data)).catch(pricingParameterValidateErrorHandler);

export const importSensitivities = (params) => {
    const formData = new FormData();
    formData.append('senstivityFile', params.senstivityFile);

    return axios.post(`/CsaImpact/ImportSenstivities?runDate=${params.runDate}&csa=${params.csa}`, formData)
        .then(r => importSensitivitiesAdapter(r.data)).catch(importSensitivitiesErrorHandler);
};

export const fxRates = params => axios.get(`/mapping/fxrates?runDate=${params}`)
    .then(r => r.data).catch(fxRatesErrorHandler);

export const getDefaultBucket = (riskType, qualifier) => axios.get(`/csaimpact/GetDefaultBasket?risktype=${riskType}&qualifier=${qualifier}`)
    .then(r => r.data).catch(defaultBucketErrorHandler);
